"use strict";

exports.__esModule = true;
exports.getCustomAppSettings = exports.getAppSettingsValue = exports.getAppSettings = void 0;

var _lodash = require("lodash");

var _wixParamsSelectors = require("../../selectors/wix-params-selectors");

var getAppSettings = function getAppSettings(state) {
  return state.appSettings;
};

exports.getAppSettings = getAppSettings;

var getAppSettingsValue = function getAppSettingsValue(_ref) {
  var style = _ref.style,
      key = _ref.key,
      fallback = _ref.fallback,
      isMobileSettingsValue = _ref.isMobileSettingsValue;
  return (0, _lodash.get)(style, (0, _wixParamsSelectors.getWixP)(key, isMobileSettingsValue), (0, _lodash.get)(style, (0, _wixParamsSelectors.getWixP)(key, false), fallback));
};

exports.getAppSettingsValue = getAppSettingsValue;

var getCustomAppSettings = function getCustomAppSettings(state) {
  return getAppSettingsValue({
    state: state,
    key: 'custom',
    fallback: {}
  });
};

exports.getCustomAppSettings = getCustomAppSettings;